export default __webpack_public_path__ + "static/media/whiteGcp.c7e9d5b1.svg";